// إعداد API Base URL للتطبيق
const API_BASE_URL = process.env.NODE_ENV === 'production' 
  ? '/api'  // للإنتاج - عبر نفس النطاق والبروتوكول من خلال Nginx reverse proxy
  : 'http://localhost:3005/api'; // للتطوير المحلي

// دالة مساعدة للتعامل مع أخطاء الخادم
export const fetchWithRetry = async (url, options = {}, retries = 3) => {
  for (let i = 0; i < retries; i++) {
    try {
      const response = await fetch(url, options);
      if (response.ok) {
        return response;
      }
      throw new Error(`HTTP ${response.status}: ${response.statusText}`);
    } catch (error) {
      console.log(`Attempt ${i + 1} failed:`, error.message);
      if (i === retries - 1) throw error;
      
      // انتظار متزايد بين المحاولات
      await new Promise(resolve => setTimeout(resolve, 1000 * (i + 1)));
    }
  }
};

export default API_BASE_URL;